import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import PageNotFound from "@/views/PageNotFound.vue";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
	{
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "contact" */ '@/views/Contact.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
  },
  {
    path: '/cookie-policy',
    name: 'Cookies',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Cookies.vue')
  },
  {
    path: '/copyright',
    name: 'Copyright',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Copyright.vue')
  },
  {
    path: '/dio',
    name: 'Dio',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Dio.vue')
  },
  {
    path: "/logos/:slug",
    name: "Item",
    components: {
      item: () => import(/* webpackChunkName: "item" */ '@/views/Item.vue')
    }
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: PageNotFound
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
